import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { LOCATIONS, CITIES, STATES } from '../globals/wp';
import * as events from '../utils/events';
import styles from './all-locations-list.pcss';

/**
 * Render the location items below the typeahead
 */

export default class AllLocationsList extends Component {
	static propTypes = {
		location: PropTypes.object,
		navigate: PropTypes.func,
	};

	static defaultProps = {
		location: {},
		navigate: () => {},
	};

	isInCurrentCity(location, city) {
		return location.city === city;
	}

	isInCurrentState(location, state) {
		return location.title && location.state === state.code && location.country === state.country;
	}

	getCitiesPerState(state) {
		const locationsInState = _.filter(LOCATIONS, location => this.isInCurrentState(location, state));
		// extract all the same cities in these locations
		let citiesPerState = _.reduce(locationsInState, (result, value, key) => {
			if (_.findIndex(result, { title: value.city }) === -1) {
				result.push({
					title: value.city,
					state: value.state,
					searchString: `${value.city}, ${value.state}`,
				});
			}
			return result;
		}, []);
		citiesPerState = _.sortBy(citiesPerState, ['title']);
		return _.map(citiesPerState, city => {
			const uniqId = _.uniqueId('city');
			return (
				<div key={uniqId} className={styles.groupSimple}>
					<button className={styles.categorySmall} data-query={city.searchString} onClick={this.handleRegionClick}>{city.title}</button>
					<ul className={styles.list}>
						{this.getLocationsByCity(city.title)}
					</ul>
				</div>
			);
		});
	}

	getStatesAndCities() {
		const sorted = _.orderBy(STATES, [state => state.name], ['asc']);
		return _.map(sorted, state => {
			return (
				<div className={styles.group} key={state.code}>
					<button className={styles.category} data-query={state.search_string} onClick={this.handleRegionClick}>{state.name}</button>
					{this.getCitiesPerState(state)}
				</div>
			);
		});
	}

	getLocationsByCity(city) {
		const locations = _.filter(LOCATIONS, location => this.isInCurrentCity(location, city));
		const sorted = _.orderBy(locations, [location => location.title], ['asc']);
		return _.map(sorted, location => {
			const uniqId = _.uniqueId('location');
			return (
				<li key={uniqId} className={styles.listItem}>
					<a className={styles.link} href={location.link} dangerouslySetInnerHTML={{__html: location.title}} />
				</li>
			);
		});
	}

	getLocationsByState(state) {
		const locations = _.filter(LOCATIONS, location => this.isInCurrentState(location, state));
		const sorted = _.orderBy(locations, [location => location.title], ['asc']);
		return _.map(sorted, location => {
			if (location.title ===	 '') {
				return '';
			}
			const uniqId = _.uniqueId('location');
			return (
				<li key={uniqId} className={styles.listItem}>
					<a className={styles.link} href={location.link} dangerouslySetInnerHTML={{__html: location.title}} />
				</li>
			)
		});
	}

	getCities() {
		const sorted = _.orderBy(CITIES, [city => city.name], ['asc']);
		return _.map(sorted, city => {
			const uniqueId = _.uniqueId('city');
			return (
				<div className={styles.group} key={uniqueId}>
					<button className={styles.category} data-query={city.search_string} onClick={this.handleRegionClick}>{city.name}</button>
					<ul className={styles.list}>{this.getLocationsByCity(city.name)}</ul>
				</div>
			);
		});
	}

	getStates() {
		const sorted = _.orderBy(STATES, [state => state.name], ['asc']);
		return _.map(sorted, state => (
			<div className={styles.group} key={state.code}>
				<button className={styles.category} data-query={state.search_string} onClick={this.handleRegionClick}>{state.name}</button>
				<ul className={styles.list}>{this.getLocationsByState(state)}</ul>
			</div>
		));
	}

	getOrganizedLocations() {
		// To show cities
		// return this.getCities();
		// return this.getStates();
		return this.getStatesAndCities();
	}

	handleRegionClick = (e) => {
		events.trigger({ event: 'modern_tribe/locator/region_click', native: false, data: {} });
		events.trigger({ event: 'modern_tribe/locator/update_query', native: false, data: { query: e.target.dataset.query } });
	};

	render() {
		return (
			<section className={styles.container}>
				<article className={styles.content}>
					{ this.getOrganizedLocations() }
				</article>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/all-locations-list.js